import { BLSFeedback } from "../pages/BLSFeedback";
import {
  FeedbackFormsListing,
  AddFeedbackFormDetails,
  EditFeedbackFormDetails,
} from "../pages/FeedbackForms";
import {
  CustomerManagement,
  CustomerDetails,
} from "../pages/CustomerManagement";
import {
  NotificationManagement,
  ViewNotificationDetails,
  EditNotification,
  AddNotification,
} from "../pages/NotificationManagement";
import {
  ContentLibrary,
  AddContentDetails,
  EditContentDetails,
  ViewContentDetails,
  LockedSessions,
  EditLockedSession,
  EditResetActivity,
} from "../pages/AudioVideoContentManagement";
import { ClickAnalytics, ClickAnalyticsDetails } from "../pages/ClickAnalytics";
import { UserAnalytics } from "../pages/UserAnalytics";
import { AdminAccess } from "../pages/AdminAccess";
import { SchoolAdminRequests } from "../pages/SchoolAdminRequests";
import { DistrictHub } from "../pages/DistrictHub";
import { AlignUsers } from "../pages/AlignUsers";
import { LicensePayments } from "../pages/LicensePayments";
import { LicensePlans } from "../pages/LicensePlans";
import { DemoAvailability } from "../pages/DemoAvailability";

import { APP_ROUTES } from "../helpers/routeHelpers";
import { Roles } from "../constants";
import { EditProfile, ChangePassword } from "../pages/Account";

let { Admin } = Roles;

const authProtectedRoutes = [
  // BLSFeedback
  {
    path: APP_ROUTES.BLS_FEEDBACK,
    component: BLSFeedback,
    permissions: [Admin],
    exact: true,
  },
  // Feedback Forms
  {
    path: APP_ROUTES.FEEDBACK_FORMS,
    component: FeedbackFormsListing,
    permissions: [Admin],
    exact: true,
  },
  {
    path: APP_ROUTES.ADD_FEEDBACK_FORM,
    component: AddFeedbackFormDetails,
    permissions: [Admin],
    exact: true,
  },
  {
    path: `${APP_ROUTES.EDIT_FEEDBACK_FORM}/:id`,
    component: EditFeedbackFormDetails,
    permissions: [Admin],
    exact: false,
  },
  // Customer Management
  {
    path: APP_ROUTES.CUSTOMER_MANAGEMENT,
    component: CustomerManagement,
    permissions: [Admin],
    exact: true,
  },
  {
    path: `${APP_ROUTES.CUSTOMER_DETAILS}/:id`,
    component: CustomerDetails,
    permissions: [Admin],
    exact: false,
  },
  // Notification Management
  {
    path: APP_ROUTES.NOTIFICATION_MANAGEMENT,
    component: NotificationManagement,
    permissions: [Admin],
    exact: true,
  },
  {
    path: `${APP_ROUTES.NOTIFICATION_DETAILS}/:id`,
    component: ViewNotificationDetails,
    permissions: [Admin],
    exact: false,
  },
  {
    path: `${APP_ROUTES.EDIT_NOTIFICATION}/:id`,
    component: EditNotification,
    permissions: [Admin],
    exact: false,
  },
  {
    path: APP_ROUTES.ADD_NOTIFICATION,
    component: AddNotification,
    permissions: [Admin],
    exact: false,
  },
  // Audio/Video Content Library
  {
    path: APP_ROUTES.CONTENT_LIBRARY,
    component: ContentLibrary,
    permissions: [Admin],
    exact: true,
  },
  {
    path: APP_ROUTES.ADD_CONTENT_LIBRARY,
    component: AddContentDetails,
    permissions: [Admin],
    exact: true,
  },
  {
    path: `${APP_ROUTES.CONTENT_LIBRARY_DETAILS}/:id`,
    component: ViewContentDetails,
    permissions: [Admin],
    exact: false,
  },
  {
    path: `${APP_ROUTES.EDIT_CONTENT_LIBRARY}/:id`,
    component: EditContentDetails,
    permissions: [Admin],
    exact: false,
  },
  {
    path: APP_ROUTES.LOCKED_SESSION_CONTENT,
    component: LockedSessions,
    permissions: [Admin],
    exact: true,
  },
  {
    path: `${APP_ROUTES.EDIT_LOCKED_SESSION}/:stateKey`,
    component: EditLockedSession,
    permissions: [Admin],
    exact: false,
  },
  {
    path: `${APP_ROUTES.EDIT_RESET_ACTIVITY}/:activity`,
    component: EditResetActivity,
    permissions: [Admin],
    exact: false,
  },
  {
    path: APP_ROUTES.EDIT_PROFILE,
    component: EditProfile,
    permissions: [Admin],
    exact: true,
  },
  {
    path: APP_ROUTES.CHANGE_PASSWORD,
    component: ChangePassword,
    permissions: [Admin],
    exact: true,
  },
  {
    path: APP_ROUTES.CLICK_ANALYTICS,
    component: ClickAnalytics,
    permissions: [Admin],
    exact: true,
  },
  {
    path: `${APP_ROUTES.CLICK_ANALYTICS_DETAILS}/:date`,
    component: ClickAnalyticsDetails,
    permissions: [Admin],
    exact: false,
  },
  {
    path: APP_ROUTES.USER_ANALYTICS,
    component: UserAnalytics,
    permissions: [Admin],
    exact: true,
  },
  {
    path: APP_ROUTES.ADMIN_ACCESS,
    component: AdminAccess,
    permissions: [Admin],
    exact: true,
  },
  {
    path: APP_ROUTES.SCHOOL_ADMIN_REQUESTS,
    component: SchoolAdminRequests,
    permissions: [Admin],
    exact: true,
  },
  {
    path: APP_ROUTES.DISTRICT_HUB,
    component: DistrictHub,
    permissions: [Admin],
    exact: true,
  },
  {
    path: APP_ROUTES.ALIGN_USERS,
    component: AlignUsers,
    permissions: [Admin],
    exact: true,
  },
  {
    path: APP_ROUTES.LICENSE_PLANS,
    component: LicensePlans,
    permissions: [Admin],
    exact: true,
  },
  {
    path: APP_ROUTES.LICENSE_PAYMENTS,
    component: LicensePayments,
    permissions: [Admin],
    exact: true,
  },
  {
    path: APP_ROUTES.DEMO_AVAILABILITY,
    component: DemoAvailability,
    permissions: [Admin],
    exact: true,
  },
];

export { authProtectedRoutes };
